import React, { useCallback, lazy, Suspense } from 'react';
import { NotesContainer, MainContainerItems } from 'src/common/components/reviewAndSubmitNotes/reviewAndSubmitNotes.styled.jsx';
import { Subtitle, NoteDetails, Edit, Del } from './CustomerCareNotes.styled';
const EditCard = lazy(() => import('./EditCard.jsx'));
import {
    checkImpersonationActive,
    checkProxyActive,
    convertTime24To12,
    logErrorToConsole,
} from 'src/utils/util';
import {
    getDisplayDate,
} from 'src/utils/dateUtils';
import MDIedit from 'src/assets/images/MDIedit.svg';
import MDIEditDisable from 'src/assets/images/MDIEditDisable.svg';
import DeleteIcon from 'src/assets/images/DeleteIcon.svg';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { FONT_FAMILY_DEMI } from 'src/styles/fonts/MCFontConstants';

const NotesOneContainer = ({
    notesOneDisplay,
    editNoteOne,
    setEditNoteOneValue,
    handleEditOne,
    handleDelete,
    setNotesCount,
    editNoteValue,
    handleCloseEditOne,
    handleEditSaveOne,
    setEditNoteOne,
    setShowSuccessMessageOne,
    CloseBlue,
    TickBlue,

}) => {
    const { displayName } = useSelector((state) => ({
        notesData: state.HeaderNotesReducer,
        displayName: state.loginReducer.hybrisUserDetails.displayName,
    }));
    const { t } = useTranslation();
    
    // Move useCallback hooks outside of the map function
    const editTextHandler = useCallback((e) => {
        setEditNoteOneValue(e.target.value);
    }, [setEditNoteOneValue]);
    
    const createBlueTickHandler = useCallback((index) => () => {
        const isEmptyValue = !editNoteValue || editNoteValue.trim() === '';
        handleEditSaveOne(index);
        setEditNoteOneValue(null);
        setEditNoteOne(null);
        if (!isEmptyValue) {
            setShowSuccessMessageOne(true);
            setTimeout(() => {
                try {
                    setShowSuccessMessageOne(false);
                }
                catch (error) {
                    logErrorToConsole(error);
                }
            }, 4000);
        }
    }, [editNoteValue, handleEditSaveOne, setEditNoteOneValue, setEditNoteOne, setShowSuccessMessageOne]);
    
  return (
      <>
          <NotesContainer margin="15px 0 0 -20px">
              {notesOneDisplay.length > 0
                  ? notesOneDisplay && notesOneDisplay
                        .filter(({ isReservationSetNote, typeOfNote }) => {
                            if (
                                isReservationSetNote === true &&
                                typeOfNote === 'BatchReservationNotes'
                            ) {
                                return false;
                            } else {
                                return true;
                            }
                        })
                        .map((item, index) => (
                            <React.Fragment key={index}>
                                <MainContainerItems
                                    setMarginBottom={true}
                                    setWidth="100%"
                                    mbSetWidth="107%"
                                    borderLeft={
                                        item.isNew
                                            ? '2px solid #12C8F7'
                                            : 'none'
                                    }
                                    paddingLeft="20px"
                                    marginLeft="-20px"
                                >
                                    <div
                                        style={{
                                            display: 'flex',
                                            justifyContent: 'space-between',
                                        }}
                                    >
                                        <Subtitle
                                            showAstrisk={false}
                                            fontSize="13px"
                                        >
                                            <b
                                                style={{
                                                    marginRight: '10px',
                                                }}
                                            >
                                                {' '}
                                                {t(
                                                    'equity.surgery.createdBy'
                                                )}{' '}
                                                {checkImpersonationActive() ||
                                                checkProxyActive()
                                                    ? sessionStorage.getItem(
                                                          'ProxyUser'
                                                      )
                                                    : (item.userName
                                                          ? item.userName
                                                          : displayName) ||
                                                      ''}{' '}
                                            </b>{' '}
                                        </Subtitle>
                                        {item?.isNew ? (
                                            <div
                                                style={{
                                                    display: 'flex',
                                                    gap: '10px',
                                                }}
                                            >
                                                <Edit>
                                                    <img
                                                        src={
                                                            editNoteOne ===
                                                            index
                                                                ? MDIEditDisable
                                                                : MDIedit
                                                        }
                                                        alt="Edit note"
                                                        onClick={() =>
                                                            handleEditOne(
                                                                item,
                                                                index
                                                            )
                                                        }
                                                    />
                                                </Edit>
                                                <Del>
                                                    <img
                                                        src={DeleteIcon}
                                                        onClick={() => {
                                                            handleDelete(
                                                                item,
                                                                index,
                                                                'notes1'
                                                            );
                                                            setNotesCount(
                                                                (prev) =>
                                                                    prev - 1
                                                            );
                                                        }}
                                                    />
                                                </Del>
                                            </div>
                                        ) : item?.isDelete ? (
                                            <div
                                                style={{
                                                    display: 'flex',
                                                    gap: '10px',
                                                }}
                                            >
                                                <Del>
                                                    <img
                                                        src={DeleteIcon}
                                                        onClick={() => {
                                                            handleDelete(
                                                                item,
                                                                index,
                                                                'notes1'
                                                            );
                                                            setNotesCount(
                                                                (prev) =>
                                                                    prev - 1
                                                            );
                                                        }}
                                                    />
                                                </Del>
                                            </div>
                                        ) : null}
                                    </div>
                                    <Subtitle>
                                        {getDisplayDate(item.creationDate)}
                                        {' | '}
                                        {convertTime24To12(
                                            new Date(item.creationDate)
                                        )}{' '}
                                    </Subtitle>
                                    {editNoteOne === index && (
                                        <Suspense fallback={<div>Loading...</div>}>
                                            <EditCard
                                                value={editNoteValue ?? item.note}
                                                editTextHandler={editTextHandler}
                                                CloseBlue={CloseBlue}
                                                closeEditHandler={
                                                    handleCloseEditOne
                                                }
                                                TickBlue={TickBlue}
                                                blueTickHandler={createBlueTickHandler(index)}
                                            />
                                        </Suspense>
                                    )}
                                    {item.typeOfNote === 'CaseNotes' ? (
                                        <>
                                            {item.updatedSurgeryDate && (
                                                <div
                                                    style={{
                                                        fontFamily: FONT_FAMILY_DEMI,
                                                        color: '#202124',
                                                        fontSize: '14px',
                                                        marginBottom: '8px',
                                                    }}
                                                >
                                                    {item.updatedSurgeryDate}
                                                </div>
                                            )}

                                            <ol
                                                type="a"
                                                style={{
                                                    paddingLeft: '16px',
                                                    color: '#202124',
                                                    fontFamily:
                                                        'AvenirNextWorld Regular',
                                                    wordBreak: 'break-all',
                                                    margin: '0',
                                                    fontSize: '15px',
                                                }}
                                            >
                                                {item.note
                                                    .split(';')
                                                    .map((element, index) => {
                                                        return (
                                                            <li key={index}>
                                                                {element}
                                                            </li>
                                                        );
                                                    })}
                                            </ol>
                                        </>
                                    ) : (
                                        editNoteOne !== index && (
                                            <NoteDetails hideBorder={true}>
                                                {item.note}
                                            </NoteDetails>
                                        )
                                    )}
                                </MainContainerItems>
                            </React.Fragment>
                        ))
                  : null}
          </NotesContainer>
      </>
  );
};

export default NotesOneContainer;